import { render, staticRenderFns } from "./product-purchase-collect.vue?vue&type=template&id=5c212acc&scoped=true&"
import script from "./product-purchase-collect.vue?vue&type=script&lang=js&"
export * from "./product-purchase-collect.vue?vue&type=script&lang=js&"
import style0 from "./product-purchase-collect.vue?vue&type=style&index=0&id=5c212acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c212acc",
  null
  
)

export default component.exports